// extracted by mini-css-extract-plugin
export default {"container":"table_container__AgWtV","tableContainer":"table_tableContainer__ZGETb","collapsedRow":"table_collapsedRow__9UpKU"};